module.exports = __webpack_public_path__ + "img/393.10cc535d.jpg";